(function () {
  if (window.__manualReviewsSliderReady) return;
  window.__manualReviewsSliderReady = true;

  function init(root) {
    if (!root || root.dataset.mtInitialized === 'true') return;
    root.dataset.mtInitialized = 'true';

      var wrap = root.querySelector('.mt__wrap');
      var track = root.querySelector('[data-mt-track]');
      var viewport = root.querySelector('[data-mt-viewport]');
      var btnPrev = root.querySelector('[data-mt-prev]');
      var btnNext = root.querySelector('[data-mt-next]');
      if (!track || !viewport || !wrap) return;

      function qsa(sel, ctx){ return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
      function clamp(v,min,max){ return Math.max(min, Math.min(max, v)); }

      function getVisibleCount() {
        var v = parseFloat(getComputedStyle(root).getPropertyValue('--mt-visible') || '0');
        if (isFinite(v) && v > 0) return v;
        return window.matchMedia('(min-width: 990px)').matches ? 3.3 : 1.12;
      }

      var state = { n: 0, step: 0, gap: 0, k: 0, visualIndex: 0 };
      var moving = false;
      var moveTimer = null;

      function getGapPx(){
        var cs = window.getComputedStyle(track);
        var g = cs.columnGap || cs.gap || '0px';
        return parseFloat(g) || 0;
      }

      function measureStep(){
        var firstReal =
          track.querySelector('[data-mt-slide]:not([data-clone="1"])') ||
          track.querySelector('[data-mt-slide]');
        if (!firstReal) return 0;

        var rect = firstReal.getBoundingClientRect();
        state.gap = getGapPx();
        state.step = rect.width + state.gap;
        return state.step;
      }

      function setTransform(px, withTransition){
        track.style.transition = withTransition ? 'transform 280ms ease' : 'none';
        track.style.transform = 'translate3d(' + (-px) + 'px,0,0)';
      }

      function clearClones(){
        qsa('[data-clone="1"]', track).forEach(function(el){ el.remove(); });
        track.removeAttribute('data-loop-ready');
      }

      function makeClone(original){
        var clone = original.cloneNode(true);
        clone.setAttribute('data-clone', '1');
        clone.querySelectorAll('video, source').forEach(function(media){
          media.removeAttribute('src');
          delete media.dataset.sourcesLoaded;
        });
        clone.querySelectorAll('[data-mt-video-wrap]').forEach(function(videoWrap){
          videoWrap.classList.remove('is-playing', 'has-played');
        });
        return clone;
      }

      function setupClones(){
        clearClones();

        var originals = qsa('[data-mt-slide]', track).filter(function(el){ return el.getAttribute('data-clone') !== '1'; });
        state.n = originals.length;

        if (state.n <= 1){ state.k = 0; return; }

        var visible = getVisibleCount();
        state.k = clamp(Math.ceil(visible) + 2, 2, state.n);

        for (var i = state.n - 1; i >= state.n - state.k; i--){
          var c1 = makeClone(originals[i]);
          track.insertBefore(c1, track.firstChild);
        }

        for (var j = 0; j < state.k; j++){
          var c2 = makeClone(originals[j]);
          track.appendChild(c2);
        }

        track.setAttribute('data-loop-ready','1');
        state.visualIndex = state.k;
      }

      function gotoVisual(idx, withTransition){
        state.visualIndex = idx;
        setTransform(state.visualIndex * state.step, withTransition);
      }

      function gotoOriginal(origIndex, withTransition){
        gotoVisual(state.k + origIndex, withTransition);
      }

      function getOriginalIndexFromVisual(){
        if (state.n <= 0) return 0;
        var oi = (state.visualIndex - state.k) % state.n;
        if (oi < 0) oi += state.n;
        return oi;
      }

      function onTransitionEnd(){
        if (state.n <= 1) return;

        var minV = state.k;
        var maxV = state.k + state.n - 1;

        if (state.visualIndex < minV){
          state.visualIndex += state.n;
          setTransform(state.visualIndex * state.step, false);
        } else if (state.visualIndex > maxV){
          state.visualIndex -= state.n;
          setTransform(state.visualIndex * state.step, false);
        }
      }

      function move(delta){
        if (state.n <= 1 || moving) return;
        measureStep();
        moving = true;
        qsa('video', root).forEach(function(video){ video.pause(); });

        state.visualIndex += delta;
        gotoVisual(state.visualIndex, true);

        moveTimer = window.setTimeout(function(){
          onTransitionEnd();
          moving = false;
        }, 320);
      }

      function setArrowY(){
        var firstMedia =
          track.querySelector('[data-mt-slide]:not([data-clone="1"]) .mt__media') ||
          track.querySelector('.mt__media');
        if (!firstMedia) return;

        var mediaRect = firstMedia.getBoundingClientRect();
        var wrapRect = wrap.getBoundingClientRect();
        var y = (mediaRect.top - wrapRect.top) + (mediaRect.height / 2);

        y = Math.max(0, Math.min(y, wrapRect.height));
        wrap.style.setProperty('--mt-arrow-y', y + 'px');
      }

      function setupVideoThumbs(scope){
        qsa('[data-mt-video-wrap]', scope || root).forEach(function(videoWrap){
          if (videoWrap.__mtVideoReady) return;
          videoWrap.__mtVideoReady = true;

          var video = videoWrap.querySelector('video');
          var playBtn = videoWrap.querySelector('[data-mt-video-play]');
          if (!video || !playBtn) return;

          var playLabel = playBtn.dataset.playLabel || playBtn.getAttribute('aria-label');
          playBtn.dataset.playLabel = playLabel;

          function showPlay(){
            videoWrap.classList.remove('is-playing');
            playBtn.setAttribute('aria-label', playLabel);
            playBtn.setAttribute('aria-pressed', 'false');
            video.controls = false;
          }

          function hidePlay(){
            videoWrap.classList.add('is-playing');
            playBtn.setAttribute('aria-label', root.dataset.pauseLabel || playLabel);
            playBtn.setAttribute('aria-pressed', 'true');
            video.controls = false;
          }

          function pauseVideo(){
            try { video.pause(); } catch (e) {}
            showPlay();
          }

          function playVideo(){
            qsa('[data-mt-video-wrap].is-playing', root).forEach(function(otherWrap){
              if (otherWrap === videoWrap) return;
              var otherVideo = otherWrap.querySelector('video');
              if (otherVideo) {
                otherVideo.pause();
                otherVideo.controls = false;
              }
              otherWrap.classList.remove('is-playing');
            });

            if (!video.dataset.sourcesLoaded) {
              video.querySelectorAll('source[data-src]').forEach(function(source){ source.src = source.dataset.src; });
              video.dataset.sourcesLoaded = 'true';
              video.load();
            }
            hidePlay();
            var promise = video.play();
            if (promise && promise.catch) promise.catch(showPlay);
          }

          var lastToggleAt = 0;
          var pointerStartX = 0;
          var pointerStartY = 0;

          function toggleVideo(e){
            e.preventDefault();
            e.stopPropagation();

            lastToggleAt = Date.now();
            if (videoWrap.classList.contains('is-playing')) {
              pauseVideo();
            } else {
              playVideo();
            }
          }

          function shouldIgnoreToggle(e){
            var target = e.target;
            return target && target.closest && target.closest('.mt__arrow, .mt__instagram');
          }

          videoWrap.addEventListener('pointerdown', function(e){
            pointerStartX = e.clientX || 0;
            pointerStartY = e.clientY || 0;
          });

          videoWrap.addEventListener('pointerup', function(e){
            if (shouldIgnoreToggle(e)) return;
            if (Date.now() - lastToggleAt < 350) {
              e.preventDefault();
              e.stopPropagation();
              return;
            }
            if (e.pointerType === 'mouse') return;
            var dx = (e.clientX || 0) - pointerStartX;
            var dy = (e.clientY || 0) - pointerStartY;
            if (Math.sqrt((dx * dx) + (dy * dy)) > 12) return;
            toggleVideo(e);
          });

          videoWrap.addEventListener('click', function(e){
            if (shouldIgnoreToggle(e)) return;
            if (Date.now() - lastToggleAt < 350) {
              e.preventDefault();
              e.stopPropagation();
              return;
            }
            toggleVideo(e);
          });

          video.addEventListener('pause', function(){
            showPlay();
          });

          video.addEventListener('ended', function(){
            showPlay();
            videoWrap.classList.remove('has-played');
            try { video.currentTime = 0; } catch (e) {}
          });

          video.addEventListener('playing', function(){
            hidePlay();
            videoWrap.classList.add('has-played');
          });

          showPlay();
        });
      }

      function initSlider(first){
        setupClones();
        measureStep();
        var startOrig = (typeof first === 'number') ? first : 0;
        startOrig = clamp(startOrig, 0, Math.max(0, state.n - 1));
        gotoOriginal(startOrig, false);
        setupVideoThumbs(root);
        setArrowY();
      }

      track.addEventListener('transitionend', onTransitionEnd);
      if (btnPrev) btnPrev.onclick = function(){ move(-1); };
      if (btnNext) btnNext.onclick = function(){ move(1); };

      (function attachSwipe(){
        if (root.__mtSwipeBound) return;
        root.__mtSwipeBound = true;

        var el = viewport;
        if (!el) return;

        var isTouch = false;
        var startX = 0, startY = 0, lastX = 0, lastY = 0;
        var isHorizontal = null;
        var suppressClickUntil = 0;

        var THRESHOLD = 35;
        var ANGLE_LOCK = 8;

        el.style.touchAction = 'pan-y';

        function onDown(e){
          var p = e.touches ? e.touches[0] : e;
          isTouch = true;
          isHorizontal = null;
          startX = lastX = p.clientX;
          startY = lastY = p.clientY;
        }

        function onMove(e){
          if (!isTouch) return;
          var p = e.touches ? e.touches[0] : e;
          lastX = p.clientX;
          lastY = p.clientY;

          var dx = lastX - startX;
          var dy = lastY - startY;

          if (isHorizontal === null){
            if (Math.abs(dx) < 2 && Math.abs(dy) < 2) return;
            if (Math.abs(dy) > Math.abs(dx) + ANGLE_LOCK){
              isHorizontal = false;
              return;
            }
            if (Math.abs(dx) > Math.abs(dy) + 2){
              isHorizontal = true;
            }
          }

          if (isHorizontal && e.cancelable) e.preventDefault();
        }

        function onUp(){
          if (!isTouch) return;
          isTouch = false;

          var dx = lastX - startX;
          var dy = lastY - startY;

          if (isHorizontal && Math.abs(dx) > Math.abs(dy)){
            if (Math.abs(dx) >= THRESHOLD){
              if (dx < 0) move(1);
              else move(-1);
              suppressClickUntil = Date.now() + 450;
            }
          }
        }

        el.addEventListener('touchstart', onDown, { passive: true });
        el.addEventListener('touchmove', onMove, { passive: false });
        el.addEventListener('touchend', onUp, { passive: true });
        el.addEventListener('touchcancel', onUp, { passive: true });

        track.addEventListener('click', function(e){
          if (Date.now() < suppressClickUntil){
            e.preventDefault();
            e.stopPropagation();
          }
        }, true);
      })();

      var resizeTimer = null;
      function onResize(){
        window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(function(){
          qsa('video', root).forEach(function(video){ video.pause(); });
          initSlider(getOriginalIndexFromVisual());
        }, 90);
      }
      window.addEventListener('resize', onResize, { passive: true });
      root.__mtDestroy = function(){
        window.removeEventListener('resize', onResize);
        window.clearTimeout(resizeTimer);
        window.clearTimeout(moveTimer);
        qsa('video', root).forEach(function(video){ video.pause(); });
      };
    initSlider();
  }

  function schedule(root) {
    if (root.__mtScheduled) return;
    root.__mtScheduled = true;
    var observer;
    function activate() {
      if (observer) observer.disconnect();
      root.removeEventListener('pointerdown', activate, true);
      root.removeEventListener('focusin', activate);
      init(root);
    }
    root.__mtCancel = function() {
      if (observer) observer.disconnect();
      root.removeEventListener('pointerdown', activate, true);
      root.removeEventListener('focusin', activate);
      if (root.__mtDestroy) root.__mtDestroy();
    };
    if (!('IntersectionObserver' in window) || (window.Shopify && Shopify.designMode)) {
      activate();
      return;
    }
    observer = new IntersectionObserver(function(entries) {
      if (entries.some(function(entry) { return entry.isIntersecting; })) activate();
    }, { rootMargin: '400px 0px' });
    observer.observe(root);
    root.addEventListener('pointerdown', activate, true);
    root.addEventListener('focusin', activate);
  }

  function forEachRoot(scope, callback) {
    var context = scope || document;
    if (context.matches && context.matches('[data-mt-root]')) callback(context);
    context.querySelectorAll('[data-mt-root]').forEach(callback);
  }

  forEachRoot(document, schedule);
  document.addEventListener('shopify:section:load', function(event) {
    forEachRoot(event.target, schedule);
  });
  document.addEventListener('shopify:section:unload', function(event) {
    forEachRoot(event.target, function(root) { if (root.__mtCancel) root.__mtCancel(); });
  });
})();
